import React from "react";
import { useParams } from "react-router-dom";
import RegisterComponent from "./component";

function RegisterPage(props) {

    return ( 
        <RegisterComponent />
        
    );
}

export default RegisterPage;